import type { Box } from 'braid-design-system';
import type { ComponentProps } from 'react';

const MARKETING = '#D5E7FF';
const MARKETING_LIGHT = '#F4F9FF';

type BraidBoxBackground = ComponentProps<typeof Box>['background'];
type BraidBackgroundProps = {
  background: BraidBoxBackground;
  style?: { background: string };
};
const createAnzBackgroundProps = (
  backgroundColour: string,
): BraidBackgroundProps => ({
  background: 'customLight',
  style: { background: backgroundColour },
});

export const useBackgroundProps = (isAnz: boolean): BraidBackgroundProps =>
  isAnz ? createAnzBackgroundProps(MARKETING_LIGHT) : { background: 'brand' };

export const useStepIndicatorBackgroundProps = (
  isAnz: boolean,
): { background: BraidBoxBackground; style?: { background: string } } =>
  isAnz ? createAnzBackgroundProps(MARKETING) : { background: 'brandAccent' };

type ConditionalWrapperProps = {
  children: React.ReactElement;
  condition: boolean;
  wrapper: (children: React.ReactElement) => JSX.Element;
};

export const ConditionalWrapper = ({
  condition,
  wrapper,
  children,
}: ConditionalWrapperProps) => (condition ? wrapper(children) : children);
